import React from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const StepRepresentanteForm = ({
  modoEdicion,
  nuevoNombreRepresentante,
  setNuevoNombreRepresentante,
  nuevoRutRepresentante,
  nuevoTelefonoRepresentante,
  nuevoCorreoRepresentante,
  nuevoRepresentantes,
  codigoPais,
  setCodigoPais,
  indiceEdicionRepresentante,
  erroresRepresentante,
  codigosPaises,
  handleRutRepresentanteChange,
  handleRutRepresentanteBlur,
  handleTelefonoRepresentanteChange,
  handleCorreoRepresentanteChange,
  handleGuardarRepresentante,
  handleEliminarRepresentante,
  handleDesactivarRepresentante,
  handleSeleccionarRepresentante,
  onPrev,
  onNext,
}) => {
  return (
    <div className="card">
      <div className="p-d-flex p-jc-between p-ai-center mb-3">
        <div>
          <h6>Ingrese los datos del representante a registrar</h6>
        </div>
      </div>

      <div className="p-fluid formgrid grid">
        {/* Rut representante */}
        <div className="field col-12 md:col-2">
          <label style={{ color: "red" }}>Rut *</label>
          <InputText
            id="rutRepresentante"
            type="text"
            value={nuevoRutRepresentante || ""}
            onChange={handleRutRepresentanteChange}
            onBlur={handleRutRepresentanteBlur}
            className={`p-inputtext-sm ${erroresRepresentante.rut ? "p-invalid" : ""}`}
            style={{
              borderRadius: "4px",
              borderColor: erroresRepresentante.rut ? "#dc3545" : "#ced4da",
            }}
            placeholder="Ingrese RUT"
            maxLength={12}
          />
          {erroresRepresentante.rut && <small className="p-error">RUT inválido</small>}
        </div>

        {/* Nombre representante */}
        <div className="field col-12 md:col-2">
          <label style={{ color: "red" }}>Nombre *</label>
          <InputText
            id="nombreRepresentante"
            type="text"
            value={nuevoNombreRepresentante || ""}
            onChange={(e) => setNuevoNombreRepresentante(e.target.value.toUpperCase())}
            className={`p-inputtext-sm ${erroresRepresentante.nombre ? "p-invalid" : ""}`}
            style={{
              borderRadius: "4px",
              borderColor: erroresRepresentante.nombre ? "#dc3545" : "#ced4da",
            }}
            placeholder="Ingrese nombre"
            maxLength={45}
          />
          {erroresRepresentante.nombre && <small className="p-error">Este campo es obligatorio</small>}
        </div>

        {/* Teléfono representante */}
        <div className="field col-12 md:col-3">
          <label style={{ color: "red" }}>Teléfono *</label>
          <div className="p-inputgroup">
            <Dropdown
              value={codigoPais}
              options={codigosPaises}
              onChange={(e) => setCodigoPais(e.value)}
              style={{ width: "50%" }}
            />
            <InputText
              id="telefonoRepresentante"
              type="text"
              value={nuevoTelefonoRepresentante || ""}
              onChange={handleTelefonoRepresentanteChange}
              className={`p-inputtext-sm ${erroresRepresentante.telefono ? "p-invalid" : ""}`}
              style={{
                borderRadius: "4px",
                borderColor: erroresRepresentante.telefono ? "#dc3545" : "#ced4da",
                width: "100%",
              }}
              placeholder="9 999 9999"
              maxLength={9}
            />
          </div>
          {erroresRepresentante.telefono && <small className="p-error">Teléfono inválido</small>}
        </div>

        {/* Correo representante */}
        <div className="field col-12 md:col-3">
          <label style={{ color: "red" }}>Correo *</label>
          <InputText
            id="correoRepresentante"
            type="email"
            value={nuevoCorreoRepresentante || ""}
            onChange={handleCorreoRepresentanteChange}
            className={`p-inputtext-sm ${erroresRepresentante.correo ? "p-invalid" : ""}`}
            style={{
              borderRadius: "4px",
              borderColor: erroresRepresentante.correo ? "#dc3545" : "#ced4da",
            }}
            placeholder="Ingrese correo"
            maxLength={45}
          />
          {erroresRepresentante.correo && <small className="p-error">Correo inválido</small>}
        </div>

        {/* Botón agregar/guardar */}
        <div className="field col-12 md:col-2 mt-4">
          <Button
            label={indiceEdicionRepresentante !== null ? "Guardar" : "Agregar"}
            icon={indiceEdicionRepresentante !== null ? "pi pi-save" : "pi pi-plus"}
            className="p-button-rounded p-button-outlined p-button-success"
            onClick={handleGuardarRepresentante}
          />
        </div>

        {/* Tabla de representantes */}
        <Card className="mt-2" style={{ width: "100%" }}>
          {nuevoRepresentantes.length > 0 ? (
            <DataTable
              value={nuevoRepresentantes}
              dataKey="id"
              scrollHeight="150px"
              className="p-datatable-sm"
              tableStyle={{ fontSize: "0.875rem" }}
            >
              <Column field="rut" header="RUT" />
              <Column field="nombre" header="Nombre" />
              <Column field="telefono" header="Teléfono" />
              <Column field="correo" header="Correo" />
              <Column
                header="Acciones"
                body={(rowData, options) => (
                  <div className="p-d-flex p-ai-center">
                    <Button
                      icon="pi pi-pencil"
                      size="small"
                      text
                      onClick={() => handleSeleccionarRepresentante(options.rowIndex)}
                    />
                    {modoEdicion ? (
                      <Button
                        icon="pi pi-times"
                        size="small"
                        severity="danger"
                        text
                        onClick={() => handleDesactivarRepresentante(options.rowIndex)}
                      />
                    ) : (
                      <Button
                        icon="pi pi-times"
                        size="small"
                        severity="danger"
                        text
                        onClick={() => handleEliminarRepresentante(options.rowIndex)}
                      />
                    )}
                  </div>
                )}
              />
            </DataTable>
          ) : (
            <p className="p-text-center">No se han agregado representantes.</p>
          )}
        </Card>
      </div>

      <br />
      <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <Button label="" icon="pi pi-arrow-left" rounded outlined onClick={onPrev} />
        <Button label="" icon="pi pi-arrow-right" rounded outlined iconPos="right" onClick={onNext} />
      </div>
    </div>
  );
};

export default StepRepresentanteForm;
